import { useEffect, useState } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js/pure'
import CheckoutForm from './checkoutForm'

const options = {
  // eslint-disable-next-line no-undef
  // clientSecret: process.env.NEXT_PUBLIC_STRIPE_SECRET_KEY
}

const StripeComponent = (props) => {
  const [stripe, setStripe] = useState(null)

  useEffect(() => {
    const fetchStripe = async () => {
      const stripeInstance = await loadStripe(
        // eslint-disable-next-line no-undef
        process.env.NEXT_PUBLIC_STRIPE_PUBLISHED_KEY
      )
      setStripe(stripeInstance)
    }

    fetchStripe()
  }, [])

  if (stripe) {
    return (
      <Elements stripe={stripe} options={options}>
        <CheckoutForm {...props} />
      </Elements>
    )
  }

  return <p>Loading Payment Method...</p>
}

export default StripeComponent
